



































import {
  Component, Vue, PropSync, Prop,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class DeleteProfile extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('profileRest', {}) profileRestSync!: any;

  public deleteProfile: string = '';

  public close() {
    this.$emit('cancel');
  }

  public onDelete() {
    this.$emit('delete');
  }

  get canDeactivate() {
    return this.profileRestSync.deleteProfile.toLowerCase().trim() === 'delete';
  }
}
